// The inline confirmation after a write (V1-INTERACTIONS §0; DS #72 Recorded, DC-26), in the glossary's words
// *Recorded · audit event* with the event's number (glossary §22 rejects V1's "Saved · Receipt #n" and Dismiss). It
// stays until the person moves to another route, RECEIPT_MS passes or they close it, so it never follows them to
// another screen (UAT F-55). A design-system island in V1's detail pane.

import { useEffect, useState } from "react";
import { Button } from "@/mc/core";
import { OVERLAY_LABELS } from "@/mc/g4b";
import { Recorded } from "@/mc/g5";

/** How long the confirmation stays while the person stays on the route. */
export const RECEIPT_MS = 8_000;

type Target = Pick<EventTarget, "addEventListener" | "removeEventListener">;

/** The receipt's life: a write shows its number; a route change, or RECEIPT_MS later, clears it. Returns the unsubscribe. */
export function watchReceipt(target: Target, set: (id: number | null) => void, ms: number = RECEIPT_MS): () => void {
  let timer: ReturnType<typeof setTimeout> | undefined;
  const stop = () => {
    if (timer !== undefined) clearTimeout(timer);
    timer = undefined;
  };
  const clear = () => {
    stop();
    set(null);
  };
  const receive = (event: Event) => {
    stop();
    set((event as CustomEvent<number>).detail);
    timer = setTimeout(clear, ms);
  };
  target.addEventListener("ta:write-receipt", receive);
  target.addEventListener("hashchange", clear);
  return () => {
    stop();
    target.removeEventListener("ta:write-receipt", receive);
    target.removeEventListener("hashchange", clear);
  };
}

/** The confirmation: his words, the audit event's number and Close. */
export function ReceiptLine({ id, onClose }: { id: number; onClose: () => void }) {
  return (
    <div className="mc screen-only write-receipt">
      <Recorded live right={<Button sm tone="ghost" onClick={onClose} >{OVERLAY_LABELS.close}</Button>}>
        <span className="mc-mono">#{id}</span>
      </Recorded>
    </div>
  );
}

export function WriteReceipt() {
  const [id, setId] = useState<number | null>(null);
  useEffect(() => watchReceipt(window, setId), []);
  return id === null ? null : <ReceiptLine id={id} onClose={() => setId(null)} />;
}
